import React from 'react';
import PropTypes from 'prop-types';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { cn } from '../../utils/lib/utils';

const Collapsible = React.forwardRef(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Root
    ref={ref}
    className={cn(className)}
    {...props}
  />
));

Collapsible.displayName = 'Collapsible';

const CollapsibleTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Trigger
    ref={ref}
    className={cn(className)}
    {...props}
  />
));

CollapsibleTrigger.displayName = 'CollapsibleTrigger';

const CollapsibleContent = React.forwardRef(({ className, ...props }, ref) => (
  <CollapsiblePrimitive.Content
    ref={ref}
    className={cn(className)}
    {...props}
  />
));

CollapsibleContent.displayName = 'CollapsibleContent';

Collapsible.propTypes = {
  className: PropTypes.string,
};

CollapsibleTrigger.propTypes = {
  className: PropTypes.string,
};

CollapsibleContent.propTypes = {
  className: PropTypes.string,
};

export { Collapsible, CollapsibleTrigger, CollapsibleContent }; 